import loadable from '@loadable/component';

export const CustomTimesWidget = loadable(
  () => import('./CustomTimesWidget/CustomTimesWidget'),
);
export const IntervalSelector = loadable(
  () => import('./CustomTimesWidget/IntervalSelector'),
);
export const DaysTableField = loadable(
  () => import('./CustomTimesWidget/DaysTableField'),
);
export const GateSelector = loadable(
  () => import('./CustomTimesWidget/GateSelector'),
);
export const PauseTableField = loadable(
  () => import('./CustomTimesWidget/PauseTableField'),
);
export const AdditionalFieldsSchemaWidget = loadable(
  () => import('./AdditionalFieldsSchemaWidget/AdditionalFieldsSchemaWidget'),
);
